import React, { useState, useEffect, useRef, useMemo } from "react";
import { PageFormLayout, FormSection, FormActions, FieldLabel } from "./ui";
import { useNavigate } from "react-router-dom";
import { api } from "../services";
import CustomDropdown from "./dropdown/CustomDropdown";
import ImagePreviewModal from "./Modals/imagePreviewModal";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import NativeInput from "./NativeInput";
import DeliveryAppPriceFields from "./DeliveryAppPriceFields";
import {
  buildAppPricesFromEditor,
  fetchPricedAppSources,
  getUniqueConnectedDeliveryApps,
} from "../utils/productAppPrice";
import { getPhoneLikeNumberError } from "../utils/validators";

function AddProduct() {
  const { t, i18n } = useTranslation("translation");
  const isArabic = i18n.language === "ar";

  const [productData, setProductData] = useState({
    nameEn: "",
    nameAr: "",
    descriptionEn: "",
    descriptionAr: "",
    productPrice: "",
    categoryId: "",
    imagePath: "",
    calories: "",
    isVisible: true,
    excludeBranches: "",
    productId: "",
    index: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [branches, setBranches] = useState([]);
  const [storeId, setStoreId] = useState(null);
  const [stores, setStores] = useState([]);
  const [selectedStoreOption, setSelectedStoreOption] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  // const [appId, setAppId] = useState(null);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [categories, setCategories] = useState([]);
  const [apps, setApps] = useState([]);
  const [addonApps, setAddonApps] = useState([]);
  const [appPrices, setAppPrices] = useState({});
  const [useDefaultAppPrices, setUseDefaultAppPrices] = useState({});
  const [customPricingEnabled, setCustomPricingEnabled] = useState(true);
  const [appPriceErrors, setAppPriceErrors] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("");
  console.log(selectedCategory);
  const [fieldErrors, setFieldErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const categoryInputRef = useRef(null);
  const [categoryDropdownWidth, setCategoryDropdownWidth] = useState(180);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const filteredCategories = categories?.filter((category) => {
    const matchesSearch = (category.name?.en || "")
      .toLowerCase()
      .includes((searchTerm || "").toLowerCase());
    const catStoreId = category?.store || category?.storeId || "";
    const matchesStore = !storeId || catStoreId === storeId;
    const notFromPos =
      category?.is_foodics !== true &&
      category?.is_tabsense !== true &&
      category?.is_partner !== true;
    return matchesSearch && matchesStore && notFromPos;
  });

   const handleCancel = () => {
    navigate(-1); // goes back to the previous page
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (categoryInputRef.current) {
      setCategoryDropdownWidth(categoryInputRef.current.offsetWidth);
    }
  }, [isOpen]);

  const handleSelect = (category) => {
    handleCategorySelect(category);
    setSearchTerm(category.name?.en || "");
    setIsOpen(false);
  };

  useEffect(() => {
    fetchStoreId();
    fetchApps();
  }, []);

  useEffect(() => {
    if (storeId) {
      fetchBranches();
      // fetchAppIdFromStore(storeId);
      fetchCategories();
    }
    // eslint-disable-next-line
  }, [storeId]);

  const deliveryApps = useMemo(
    () => getUniqueConnectedDeliveryApps(apps, addonApps),
    [apps, addonApps]
  );

  useEffect(() => {
    if (!deliveryApps.length) return;
    setUseDefaultAppPrices((prev) => {
      const next = { ...prev };
      let changed = false;
      deliveryApps.forEach((app) => {
        if (next[app.key] === undefined) {
          next[app.key] = true;
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [deliveryApps]);

  const fetchApps = async () => {
    try {
      const { apps: nextApps, addonApps: nextAddonApps } =
        await fetchPricedAppSources();
      setApps(nextApps);
      setAddonApps(nextAddonApps);
    } catch (err) {
      console.error("Error fetching apps:", err.response?.data || err.message);
    }
  };

  // Fetch Store ID
  const fetchStoreId = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get("/stores/my", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.data?.stores?.length) {
        throw new Error(`${t("No stores found.")}`);
      }
      const allStores = response.data.stores || [];
      // Load stores but do not preselect any; show placeholder "Select a store"
      setStores(allStores);
      setStoreId(null);
      setSelectedStoreOption(null);
    } catch (error) {
      console.error(
        "Error fetching store ID:",
        error.response?.data || error.message
      );
      setError(`${t("Failed to fetch store.")}`);
    }
  };

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("token");
      // Fetch first page with a large limit, or iterate if you want all
      let allCategories = [];
      let page = 1;
      let totalPages = 1;
      do {
        const response = await api.get(`/categories?page=${page}&limit=100`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const cats = Array.isArray(response.data?.categories)
          ? response.data.categories
          : [];
        allCategories = allCategories.concat(cats);
        totalPages = response.data?.totalPages || 1;
        page++;
      } while (page <= totalPages);
      setCategories(allCategories);
    } catch (error) {
      console.error(
        "Error fetching categories:",
        error.response?.data || error.message
      );
      setError(`${t("Failed to fetch categories.")}`);
    }
  };

  // Fetch Branches for Selected Store
  const fetchBranches = async () => {
    if (!storeId) return;

    try {
      const token = localStorage.getItem("token");
      const response = await api.get(`/stores/${storeId}/branches`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setBranches(response.data.branches || []);
    } catch (error) {
      console.error(
        "Error fetching branches:",
        error.response?.data || error.message
      );
      setError(`${t("Failed to fetch branches.")}`);
    }
  };

  // Fetch App ID from Store
  // const fetchAppIdFromStore = async (storeId) => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     const response = await api.get(`/stores/${storeId}/apps`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });

  //     if (!response.data?.apps?.length) {
  //       throw new Error("No apps found for the selected store.");
  //     }

  //     setAppId(response.data.apps[0]._id);
  //   } catch (error) {
  //     console.error(
  //       "Error fetching App ID:",
  //       error.response?.data || error.message
  //     );
  //     setError("Failed to fetch App ID.");
  //   }
  // };

  // Handle Branch Selection
  const handleBranchSelect = (branch) => {
    setSelectedBranch(branch.name);
    setSelectedBranchId(branch._id);
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    handleFieldChange("categoryId", category._id);
    if (fieldErrors.selectedCategory) {
      setFieldErrors((prev) => ({ ...prev, selectedCategory: undefined }));
    }
  };

  // Handle Field Input Change
  const handleFieldChange = (field, value) => {
    // Update value first
    setProductData((prev) => ({ ...prev, [field]: value }));
    
    // Check for required fields
    const requiredFields = {
      nameEn: t("Name (EN) is required."),
      nameAr: t("Name (AR) is required."),
      descriptionEn: t("Description (EN) is required."),
      descriptionAr: t("Description (AR) is required."),
      productPrice: t("Price is required.")
    };

    // Check for language-specific validation
    let message;
    if (field === "nameEn" || field === "descriptionEn") {
      if (value.trim() === '') {
        message = requiredFields[field];
      } else {
        const phoneError = getPhoneLikeNumberError(value, t);
        if (phoneError) {
          message = phoneError;
        } else if (/[\u0600-\u06FF]/.test(value)) {
          message = field === "nameEn"
            ? t("English name must only contain English letters and numbers.")
            : t("English description must only contain English letters and numbers.");
        }
      }
    } else if (field === "nameAr" || field === "descriptionAr") {
      if (value.trim() === '') {
        message = requiredFields[field];
      } else {
        const phoneError = getPhoneLikeNumberError(value, t);
        if (phoneError) {
          message = phoneError;
        } else if (/[A-Za-z]/.test(value)) {
          message = field === "nameAr"
            ? t("Arabic name must only contain Arabic letters and numbers.")
            : t("Arabic description must only contain Arabic letters and numbers.");
        }
      }
    } else if (field === "productPrice") {
      if (value.trim() === '') {
        message = requiredFields[field];
      } else if (isNaN(value) || Number(value) < 0.01 || !/^([1-9]\d*|0)?(\.\d{1,2})?$/.test(value)) {
        message = t("Please enter valid price");
      }
    } else if (field === "calories") {
      // Calories field is optional - no validation
      message = undefined;
    }

    // Update field errors
    setFieldErrors(prev => ({
      ...prev,
      [field]: message || (requiredFields[field] && value.trim() === '' ? requiredFields[field] : undefined)
    }));
  };

  // Handle Image Upload
 // ... (previous imports remain the same)

const handleImageUpload = async () => {
  if (!imageFile) {
    setError(`${t("Image file is required.")}`);
    return null;
  }

  try {
    const formData = new FormData();
    formData.append("image", imageFile);

    const token = localStorage.getItem("token");
    const response = await api.post("/products/upload", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("Image upload response:", response);
    return response.data.imagePath;
  } catch (error) {
    console.error("Error uploading image:", error);
    toast.error(error.response?.data?.message || `${t("Upload failed.")}`);
    return null;
  }
};

// ... (rest of the component remains the same)

  // Handle Save Product
  const handleSave = async () => {
    // Field-level validation
    const errors = {};
    // if (!selectedBranchId) errors.selectedBranch = "Branch is required.";
    if (!selectedCategory || !selectedCategory._id)
      errors.selectedCategory = `${t("Category is required.")}`;
    if (!productData.nameEn.trim()) errors.nameEn = `${t("Name (EN) is required.")}`;
    if (!productData.nameAr.trim()) errors.nameAr = `${t("Name (AR) is required.")}`;
    if (!productData.descriptionEn.trim())
      errors.descriptionEn = `${t("Description (EN) is required.")}`;
    if (!productData.descriptionAr.trim())
      errors.descriptionAr = `${t("Description (AR) is required.")}`;
    // Price validation
    if (
      !productData.productPrice ||
      isNaN(productData.productPrice) ||
      Number(productData.productPrice) < 0.01 ||
      !/^([1-9]\d*|0)?(\.\d{1,2})?$/.test(productData.productPrice) ||
      (productData.productPrice.length > 1 &&
        productData.productPrice[0] === "0" &&
        productData.productPrice[1] !== ".")
    ) {
      errors.productPrice = `${t("Please enter valid price")}`;
    }

    const nextAppPriceErrors = {};
    if (customPricingEnabled) {
      deliveryApps.forEach((app) => {
        if (useDefaultAppPrices[app.key] !== false) return;
        const raw = appPrices[app.key];
        if (
          raw === undefined ||
          raw === "" ||
          isNaN(raw) ||
          Number(raw) < 0.01 ||
          !/^([1-9]\d*|0)?(\.\d{1,2})?$/.test(String(raw))
        ) {
          nextAppPriceErrors[app.key] = t("Please enter valid price");
        }
      });
    }
    setAppPriceErrors(nextAppPriceErrors);

    // Store validation
    if (!storeId) {
      errors.storeId = `${t("Store is required")}`;
    }
    if (!imageFile) errors.imageFile = `${t("Image is required.")}`;
    
    // Additional validation for character restrictions
    if (productData.nameEn.trim() && !/^[a-zA-Z0-9\s]*$/.test(productData.nameEn)) {
      errors.nameEn = `${t("English name must only contain English letters and numbers.")}`;
    }
    if (productData.nameAr.trim() && !/^[\u0600-\u06FF0-9\s]*$/.test(productData.nameAr)) {
      errors.nameAr = `${t("Arabic name must only contain Arabic letters and numbers.")}`;
    }
    if (productData.descriptionEn.trim() && !/^[a-zA-Z0-9\s]*$/.test(productData.descriptionEn)) {
      errors.descriptionEn = `${t("English description must only contain English letters and numbers.")}`;
    }
    if (productData.descriptionAr.trim() && !/^[\u0600-\u06FF0-9\s]*$/.test(productData.descriptionAr)) {
      errors.descriptionAr = `${t("Arabic description must only contain Arabic letters and numbers.")}`;
    }

    ["nameEn", "nameAr", "descriptionEn", "descriptionAr"].forEach((field) => {
      const phoneError = getPhoneLikeNumberError(productData[field], t);
      if (phoneError) errors[field] = phoneError;
    });
    
    setFieldErrors(errors);
    setError("");
    
    // Check both new errors and existing field errors
    if (
      Object.keys(errors).length > 0 ||
      Object.keys(nextAppPriceErrors).length > 0 ||
      Object.values(fieldErrors).some((error) => error)
    ) {
      return;
    }
    
    setIsSubmitting(true); // Only disable button when actually submitting

   

     const imagePath = await handleImageUpload();
     console.log("imagePath",imagePath);
     
  if (!imagePath) {
    
    setIsSubmitting(false);
    return;
  }
  
  // Language mismatch checks (do not block typing, but block save if mismatched)
  if (/[\u0600-\u06FF]/.test(productData.nameEn)) {
    errors.nameEn = t("English name must only contain English letters and numbers.");
    setIsSubmitting(false);
    setFieldErrors((prev) => ({ ...prev, nameEn: errors.nameEn }));
    return;
  }
  if (/[\u0600-\u06FF]/.test(productData.descriptionEn)) {
    errors.descriptionEn = t("English description must only contain English letters and numbers.");
    setIsSubmitting(false);
    setFieldErrors((prev) => ({ ...prev, descriptionEn: errors.descriptionEn }));
    return;
  }
  if (/[A-Za-z]/.test(productData.nameAr)) {
    errors.nameAr = t("Arabic name must only contain Arabic letters and numbers.");
    setIsSubmitting(false);
    setFieldErrors((prev) => ({ ...prev, nameAr: errors.nameAr }));
    return;
  }
  if (/[A-Za-z]/.test(productData.descriptionAr)) {
    errors.descriptionAr = t("Arabic description must only contain Arabic letters and numbers.");
    setIsSubmitting(false);
    setFieldErrors((prev) => ({ ...prev, descriptionAr: errors.descriptionAr }));
    return;
  }

   const payload = {
    // Legacy schema that previously succeeded
    storeId,
    productId: productData.productId || null,
    name: { en: productData.nameEn, ar: productData.nameAr },
    description: { en: productData.descriptionEn, ar: productData.descriptionAr },
    productPrice: Number(productData.productPrice),
    app_prices: buildAppPricesFromEditor({
      deliveryApps,
      values: appPrices,
      useDefault: useDefaultAppPrices,
      customPricingEnabled,
    }),
    categoryId: productData.categoryId,
    imagePath: imagePath,
    calories: Number(productData.calories),
    isVisible: !!productData.isVisible,
    excludeBranches: [],
    index: parseInt(productData.index) || 0,
  };

    try {
      const token = localStorage.getItem("token");
      console.log(" Sending Create Product Payload:", payload); //  Debugging Log
      const response = await api.post("/products", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

     
     toast.success(t("productApiMsgs.addedSuccessfully"), {
  autoClose: 500, // time in milliseconds
});
      // isSubmitting remains true after success
      setTimeout(() => navigate("/products"), 1500);
    } catch (error) {
      console.error(
        " Error adding product:",
        error.response?.data || error.message
      );
      const backendErrors = error.response?.data?.errors;
      if (Array.isArray(backendErrors)) {
        const nextFieldErrors = { ...fieldErrors };
        backendErrors.forEach((msg) => {
          const lower = String(msg).toLowerCase();
          if (lower.includes("price")) {
            nextFieldErrors.productPrice = msg;
          }
          if (lower.includes("category id")) {
            nextFieldErrors.selectedCategory = msg;
          }
        });
        setFieldErrors(nextFieldErrors);
      }
      toast.error(`${t("Failed to add product.")}`);
      setError(error.response?.data?.message || `${t("Failed to add product.")}`);
      setIsSubmitting(false); // Re-enable button on error
    }
  };

  return (
    <PageFormLayout rootClass="add-product" title={t("addproduct")}>
      {error && (
        <div className="alert alert-danger oh-form-alert" role="alert">
          {error}
        </div>
      )}

      <FormSection title={t("productdetails")}>
        <div className="oh-form-grid">
          <div className={`oh-field${fieldErrors.storeId ? " oh-field--invalid" : ""}`}>
            <FieldLabel required tooltip={t("formTooltips.productStore")}>
              {t("Select store")}
            </FieldLabel>
            <CustomDropdown
              options={stores}
              showLable={false}
              invalid={!!fieldErrors.storeId}
              selectedOption={selectedStoreOption}
              handleSelect={(store) => {
                setSelectedStoreOption(store);
                const id = store?._id || null;
                setStoreId(id);
                setSelectedCategory("");
                handleFieldChange("categoryId", "");
                setFieldErrors((prev) => ({
                  ...prev,
                  storeId: id ? "" : t("Store is required"),
                }));
              }}
              placeholder={t("Select a store")}
            />
            <div className="oh-field__error invalid-feedback">
              {fieldErrors.storeId || ""}
            </div>
          </div>

          <div className={`oh-field${fieldErrors.selectedCategory ? " oh-field--invalid" : ""}`}>
            <FieldLabel required tooltip={t("formTooltips.productCategory")}>
              {t("selectcategory")}
            </FieldLabel>
            <CustomDropdown
              options={filteredCategories}
              showLable={false}
              invalid={!!fieldErrors.selectedCategory}
              selectedOption={selectedCategory}
              handleSelect={(val) => {
                setSelectedCategory(val);
                handleFieldChange("categoryId", val?._id);
                if (fieldErrors.selectedCategory) {
                  setFieldErrors((prev) => ({
                    ...prev,
                    selectedCategory: undefined,
                  }));
                }
              }}
              placeholder={t("Select a category")}
              emptyMenuWidth="120%"
              emptyItemStyle={{ borderRadius: 2 }}
            />
            <div className="oh-field__error invalid-feedback">
              {fieldErrors.selectedCategory || ""}
            </div>
          </div>

          <NativeInput
            id="nameEn"
            label={t("nameen")}
            required
            tooltip={t("formTooltips.productNameEn")}
            type="text"
            value={productData.nameEn}
            onChange={(e) => handleFieldChange("nameEn", e.target.value)}
            placeholder={t("enterproductnameinenglish")}
            invalid={!!fieldErrors.nameEn}
            feedback={fieldErrors.nameEn}
          />

          <NativeInput
            id="nameAr"
            label={t("namear")}
            required
            tooltip={t("formTooltips.productNameAr")}
            type="text"
            value={productData.nameAr}
            onChange={(e) => handleFieldChange("nameAr", e.target.value)}
            placeholder={t("enterproductnameinarabic")}
            invalid={!!fieldErrors.nameAr}
            feedback={fieldErrors.nameAr}
          />

          <NativeInput
            id="descriptionEn"
            label={t("descriptionen")}
            required
            tooltip={t("formTooltips.productDescriptionEn")}
            type="text"
            value={productData.descriptionEn}
            onChange={(e) =>
              handleFieldChange("descriptionEn", e.target.value)
            }
            placeholder={t("enterproductdescriptioninenglish")}
            invalid={!!fieldErrors.descriptionEn}
            feedback={fieldErrors.descriptionEn}
          />

          <NativeInput
            id="descriptionAr"
            label={t("descriptionar")}
            required
            tooltip={t("formTooltips.productDescriptionAr")}
            type="text"
            value={productData.descriptionAr}
            onChange={(e) =>
              handleFieldChange("descriptionAr", e.target.value)
            }
            placeholder={t("enterproductdescriptioninarabic")}
            invalid={!!fieldErrors.descriptionAr}
            feedback={fieldErrors.descriptionAr}
          />

          <NativeInput
            id="productPrice"
            label={t("productprice")}
            required
            tooltip={t("formTooltips.productPrice")}
            type="text"
            value={productData.productPrice}
            onChange={(e) => {
              let value = e.target.value;
              if (value === "") {
                handleFieldChange("productPrice", value);
                setFieldErrors((prev) => ({
                  ...prev,
                  productPrice: t("Please enter valid price"),
                }));
                return;
              }
              if (
                value.length > 1 &&
                value[0] === "0" &&
                value[1] !== "."
              ) {
                value = value.replace(/^0+/, "");
              }
              if (/^([1-9]\d*|0)?(\.\d{0,2})?$/.test(value)) {
                handleFieldChange("productPrice", value);
                if (value && !isNaN(value) && Number(value) >= 0.01) {
                  setFieldErrors((prev) => {
                    const { productPrice, ...rest } = prev;
                    return rest;
                  });
                } else {
                  setFieldErrors((prev) => ({
                    ...prev,
                    productPrice: t("Please enter valid price"),
                  }));
                }
              }
            }}
            placeholder="e.g. 12.50"
            invalid={!!fieldErrors.productPrice}
            feedback={fieldErrors.productPrice}
          />

          <DeliveryAppPriceFields
            deliveryApps={deliveryApps}
            values={appPrices}
            useDefault={useDefaultAppPrices}
            customPricingEnabled={customPricingEnabled}
            defaultPrice={productData.productPrice}
            errors={appPriceErrors}
            disabled={isSubmitting}
            onChange={(key, value) => {
              setAppPrices((prev) => ({ ...prev, [key]: value }));
              setAppPriceErrors((prev) => {
                const next = { ...prev };
                delete next[key];
                return next;
              });
            }}
            onToggleUseDefault={(key, checked) => {
              setUseDefaultAppPrices((prev) => ({ ...prev, [key]: checked }));
              setAppPriceErrors((prev) => {
                const next = { ...prev };
                delete next[key];
                return next;
              });
            }}
            onToggleCustomPricing={(enabled) => {
              setCustomPricingEnabled(enabled);
              if (enabled) {
                setUseDefaultAppPrices((prev) => {
                  const next = { ...prev };
                  deliveryApps.forEach((app) => {
                    if (next[app.key] === undefined) next[app.key] = true;
                  });
                  return next;
                });
              } else {
                setAppPriceErrors({});
              }
            }}
          />

          <NativeInput
            id="calories"
            label={t("calories")}
            tooltip={t("formTooltips.productCalories")}
            type="text"
            value={productData.calories}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || /^\d+$/.test(value)) {
                handleFieldChange("calories", value);
                setFieldErrors((prev) => {
                  const { calories, ...rest } = prev;
                  return rest;
                });
              }
            }}
            placeholder="e.g. 0, 250"
            invalid={!!fieldErrors.calories}
            feedback={fieldErrors.calories}
          />

          <div className="oh-form-grid__span-2 oh-field">
            <FieldLabel required tooltip={t("formTooltips.productImage")}>
              {t("uploadimage")}
            </FieldLabel>

  {/* Combined Image Upload and Preview Field */}
  <div
    style={{
      width: "100%",
      height: 160,
      borderRadius: 8,
      border: `1px ${imagePreview ? "solid" : "dashed"} #e0e0e0`,
      backgroundColor: imagePreview ? "#f8f8f8" : "#fafafa",
      position: "relative",
      overflow: "hidden",
      cursor: imagePreview ? "default" : "pointer",
      transition: "all 0.2s ease",
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
    }}
    onClick={() => {
      if (!imagePreview) {
        document.getElementById('hidden-file-input').click();
      }
    }}
  >
    {/* Hidden file input */}
   <input
  id="hidden-file-input"
  type="file"
  accept="image/png, image/jpeg, image/jpg"
  onChange={async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate MIME type
    const validTypes = ["image/jpeg", "image/png"];
    if (!validTypes.includes(file.type)) {
      toast.error(t("Only JPG, JPEG, and PNG images are allowed."));
      e.target.value = ''; // Reset input to allow reselecting same file
      return;
    }

    // Validate file extension
    const fileName = file.name.toLowerCase();
    const validExtensions = ['.jpg', '.jpeg', '.png'];
    const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));
    
    if (!hasValidExtension) {
      toast.error(t("Only JPG, JPEG, and PNG images are allowed."));
      e.target.value = ''; // Reset input to allow reselecting same file
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error(t("Image size must be less than 5MB."));
      e.target.value = ''; // Reset input to allow reselecting same file
      return;
    }

    const dimensions = await new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = () => {
        resolve(null);
      };
      img.src = URL.createObjectURL(file);
    });

    if (!dimensions) {
      toast.error(t("Failed to read image dimensions."));
      e.target.value = ''; // Reset input to allow reselecting same file
      return;
    }

    if (dimensions.width < 600 || dimensions.height < 450) {
      toast.error(t("Image must be at least 600px wide and 450px tall."));
      e.target.value = ''; // Reset input to allow reselecting same file
      return;
    }

    // If all checks pass, clear any existing errors
    setFieldErrors((prev) => ({
      ...prev,
      imageFile: undefined,
    }));

    // Set the image file and preview
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = (event) => {
      setImagePreview(event.target.result);
    };
    reader.readAsDataURL(file);
  }}
  style={{ display: "none" }}
/>

    {imagePreview ? (
      <>
        {/* Preview Image */}
        <img
          src={imagePreview}
          alt="Preview"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            background: "linear-gradient(45deg, #f5f5f5 25%, #fff 25%, #fff 50%, #f5f5f5 50%, #f5f5f5 75%, #fff 75%, #fff 100%)",
            backgroundSize: "20px 20px"
          }}
        />
        
        {/* Button Container (always visible) */}
        <div
          style={{
            position: "absolute",
            bottom: "16px",
            right: "16px",
            display: "flex",
            gap: "8px",
          }}
        >
          {/* View Button */}
          <div
            style={{
              backgroundColor: "rgba(255,255,255,0.9)",
              color: "#333",
              padding: "8px 16px",
              borderRadius: "20px",
              fontSize: "13px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              border: "1px solid rgba(0,0,0,0.1)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: "500",
              cursor: "pointer"
            }}
            onClick={(e) => {
              e.stopPropagation();
              setShowModal(true);
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            {t("view")}
          </div>
          
          {/* Replace Button */}
          <div
            style={{
              backgroundColor: "rgba(255,255,255,0.9)",
              color: "#333",
              padding: "8px 16px",
              borderRadius: "20px",
              fontSize: "13px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              border: "1px solid rgba(0,0,0,0.1)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: "500",
              cursor: "pointer"
            }}
            onClick={(e) => {
              e.stopPropagation();
              document.getElementById('hidden-file-input').click();
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
            Replace
          </div>
        </div>
      </>
    ) : (
      /* Empty State */
      <div style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#666",
        padding: "20px",
        textAlign: "center"
      }}>
        <div style={{
          width: "48px",
          height: "48px",
          borderRadius: "50%",
         
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "12px"
        }}>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="#888" 
            strokeWidth="2"
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <polyline points="21 15 16 10 5 21"></polyline>
          </svg>
        </div>
        <div style={{ 
          fontSize: "15px",
          fontWeight: "500",
          marginBottom: "4px"
        }}>
          {t("clicktouploadimage")}
        </div>
        <div style={{ 
          fontSize: "12px", 
          color: "#999",
          lineHeight: "1.4"
        }}>
          {t("supports")}: PNG, JPG, JPEG<br />
  {t("minimumdimensions")}: 600x450px<br />
  {t("maxsize")}: 5MB ({t("recomendedunder2mb")})<br />
{t("recomendedaspectratio")}: 4:3
        </div>
      </div>
      
    )}
  </div>
            <div className="oh-field__error invalid-feedback">
              {fieldErrors.imageFile || ""}
            </div>

            {showModal && (
              <ImagePreviewModal
                imagePreview={imagePreview}
                onClose={() => setShowModal(false)}
              />
            )}
          </div>
        </div>
      </FormSection>

      <FormActions
        isRtl={isArabic}
        cancelLabel={t("cancel")}
        saveLabel={t("save")}
        savingLabel={t("saving")}
        onCancel={handleCancel}
        onSave={handleSave}
        saving={isSubmitting}
      />
    </PageFormLayout>
  );
}

export default AddProduct;
